// Base API URL - adjust this based on your environment
//export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Other config values can be added here 
const getApiUrl = () => {
    switch (process.env.REACT_APP_ENV) {
      case 'production':
        return process.env.REACT_APP_API_URL || 'https://your-production-url.com/api';
      default:
        return process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
    }
  };
  
  export const API_URL = getApiUrl();
  
  export const endpoints = {
    signin: `${API_URL}/auth/signin`,
    signup: `${API_URL}/auth/signup`,
    // resetpPassword: `${API_URL}/auth/reset-password`,
  
  }; 